import script from "./TheCall.vue?vue&type=script&setup=true&lang=ts"
export * from "./TheCall.vue?vue&type=script&setup=true&lang=ts"

import "./TheCall.vue?vue&type=style&index=0&id=6dbaec5a&lang=scss"

const __exports__ = script;

export default __exports__